export const FIND_OPEN_PROCESS_STATEMENT_FAILURE = 'FIND_OPEN_PROCESS_STATEMENT_FAILURE';

export const findOpenProcessStatementFailure = error => ({
    type: FIND_OPEN_PROCESS_STATEMENT_FAILURE,
    payload: error,
    error: true,
});
